export enum EAthenaMessageTypes {
    LOGIN_SUCCESS = "login-success",
    SCRAPE_ATHENA_DOM = "scrape-athena-dom",
    CDI_REPORT_LOADING_COMPLETE = "cdi-report-loading-complete",
    RISK_GAP_COUNT = "risk-gap-count",
    QUERIES_COUNT = "queries-count",
    CLEAR_PULLTAB_COUNT = "clear-pulltab-count",
    NAVIGATE_TO_PATIENT = "navigate-to-patient",
    LOGOUT_SUCCESS = "logout-success",
    PROVIDER_RISK_GAPS_SAVED = "provider-risk-gaps-saved",
    APP_COMPONENT_INITIALIZED = "app-component-initialized",
}
